import React, { Component, PropTypes } from 'react'

import SetupformSummary from './setupform-summary'
import LoadingSpinner from 'components/loading-spinner'

class SetupformSummaryContainer extends Component {

  render() {
    if (!this.props.setupform) {
      return <LoadingSpinner />
    }

    return <SetupformSummary {...this.props} />
  }

}

SetupformSummaryContainer.propTypes = {
  setupform: PropTypes.object,
  instances: PropTypes.array,
  venue: PropTypes.object,
}

export default SetupformSummaryContainer



/** WEBPACK FOOTER **
 ** ./src/components/setupform-summary/setupform-summary-container.js
 **/